// =============================================================================
// Sandbox ⇄ Live view mode (test users only)
// =============================================================================
// A tiny external store, mirrored to the `X-View-Mode` request header by the API
// client. Only meaningful for test users (User.isTest): it lets them flip
// between their sandbox data (default) and a READ-ONLY view of live data.
//
// Real users never send a meaningful value — the backend forces isTest=false for
// them regardless. Writes are always sandbox for a test user (the order is
// stamped from the user flag at creation), so this only ever affects READS.

export type ViewMode = 'sandbox' | 'live';

const KEY = 'kalachand.viewMode';
const listeners = new Set<() => void>();

function read(): ViewMode {
  return localStorage.getItem(KEY) === 'live' ? 'live' : 'sandbox';
}

let current: ViewMode = read();

export function getViewMode(): ViewMode {
  return current;
}

/** The header value the API client attaches. */
export function viewModeHeader(): string {
  return current;
}

export function setViewMode(mode: ViewMode): void {
  if (mode === current) return;
  current = mode;
  localStorage.setItem(KEY, mode);
  for (const l of listeners) l();
}

export function subscribeViewMode(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
